/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * CompletedRoutesInsightsDtoBase
 * auto generated base class for the model CompletedRoutesInsightsDtoModel.
 */
export const CompletedRoutesInsightsDtoModelBase = ModelBase
  .named('CompletedRoutesInsightsDto')
  .props({
    __typename: types.optional(types.literal("CompletedRoutesInsightsDto"), "CompletedRoutesInsightsDto"),
    startDate: types.union(types.undefined, types.null, types.string),
    endDate: types.union(types.undefined, types.null, types.string),
    projectId: types.union(types.undefined, types.null, types.integer),
    driverId: types.union(types.undefined, types.null, types.integer),
    completedWorkingTime: types.union(types.undefined, types.null, types.integer),
    estimatedDistanceCompleted: types.union(types.undefined, types.null, types.integer),
    completedRoutes: types.union(types.undefined, types.null, types.integer),
    completedOrders: types.union(types.undefined, types.null, types.integer),
    deliveredOrders: types.union(types.undefined, types.null, types.integer),
    missedOrders: types.union(types.undefined, types.null, types.integer),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CompletedRoutesInsightsDtoModelSelector extends QueryBuilder {
  get startDate() { return this.__attr(`startDate`) }
  get endDate() { return this.__attr(`endDate`) }
  get projectId() { return this.__attr(`projectId`) }
  get driverId() { return this.__attr(`driverId`) }
  get completedWorkingTime() { return this.__attr(`completedWorkingTime`) }
  get estimatedDistanceCompleted() { return this.__attr(`estimatedDistanceCompleted`) }
  get completedRoutes() { return this.__attr(`completedRoutes`) }
  get completedOrders() { return this.__attr(`completedOrders`) }
  get deliveredOrders() { return this.__attr(`deliveredOrders`) }
  get missedOrders() { return this.__attr(`missedOrders`) }
}
export function selectFromCompletedRoutesInsightsDto() {
  return new CompletedRoutesInsightsDtoModelSelector()
}

export const completedRoutesInsightsDtoModelPrimitives = selectFromCompletedRoutesInsightsDto().startDate.endDate.projectId.driverId.completedWorkingTime.estimatedDistanceCompleted.completedRoutes.completedOrders.deliveredOrders.missedOrders
